import { useState } from 'react';
import Button from 'src/components/Button';
import Dropdown from 'src/components/Dropdown';
import DropdownContent from 'src/components/DropdownContent';
import { DropdownItem } from 'src/components/DropdownItem';
import DropdownTrigger from 'src/components/DropdownTrigger';
import { useActivityTranslation } from 'src/hooks/useActivityTranslation';
import useTimeFormat from 'src/hooks/useTimeFormat';
import { IconTripleDots } from 'src/icons';
import { StudentActivityListItem } from 'src/pages/single-student/singleStudent.types';

import { formatMinutesToHours } from './Activities.utils';
import { ActivityModal } from './ActivityModal';
import { DeleteActivityModal } from './DeleteActivityModal';

type ActivityCardProps = {
  activity: StudentActivityListItem;
};

export const ActivityCard = ({ activity }: ActivityCardProps) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { translateActivity } = useActivityTranslation();
  const { formatDateOnly, formatDateTime } = useTimeFormat();

  return (
    <>
      <div className="flex w-full flex-col gap-2 rounded-lg bg-neutral-white p-4 shadow-elevation-2">
        <div className="flex items-center justify-between">
          <p className="text-body-xs-desktop text-neutral-300">
            {formatDateOnly(activity.date, 'MMM d, yyyy')},{' '}
            {formatMinutesToHours(activity.durationInMinutes)}
          </p>
          <Dropdown>
            <DropdownTrigger>
              <Button preset="ghost" Icon={IconTripleDots} className="h-6 w-6 p-0" />
            </DropdownTrigger>
            <DropdownContent className="w-36" align="end" side="bottom">
              <DropdownItem handleClick={() => setIsEditModalOpen(true)}>Edit</DropdownItem>
              <DropdownItem handleClick={() => setIsDeleteModalOpen(true)}>Delete</DropdownItem>
            </DropdownContent>
          </Dropdown>
        </div>
        <p className="text-body-sm-desktop font-medium text-neutral-100">
          {translateActivity(activity.name)}
        </p>
        {activity.note && (
          <p className="mt-2 text-body-xs-desktop text-neutral-100">{activity.note}</p>
        )}
      </div>

      <DeleteActivityModal
        open={isDeleteModalOpen}
        onOpenChange={setIsDeleteModalOpen}
        activityId={activity.id}
      />

      <ActivityModal
        open={isEditModalOpen}
        onOpenChange={setIsEditModalOpen}
        activity={activity}
        month={new Date(formatDateTime(activity.date)).getMonth() + 1}
        year={new Date(formatDateTime(activity.date)).getFullYear()}
        enableOnlyProvidedMonthAndYear={true}
      />
    </>
  );
};
